var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGearwheel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_881",
    "data-name": "Group 881",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "secondary",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(11 11)",
    fill: "none",
    stroke: "#16c6d8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M25.667,12.333H24.88a1.333,1.333,0,0,1-1.253-.893h0a1.333,1.333,0,0,1,.267-1.52l.547-.547a1.333,1.333,0,0,0,0-1.893L22.547,5.573a1.333,1.333,0,0,0-1.893,0l-.547.547a1.333,1.333,0,0,1-1.52.267h0a1.333,1.333,0,0,1-.92-1.267V4.333A1.333,1.333,0,0,0,16.333,3H13.667a1.333,1.333,0,0,0-1.333,1.333V5.12a1.333,1.333,0,0,1-.893,1.253h0a1.333,1.333,0,0,1-1.52-.267L9.373,5.56a1.333,1.333,0,0,0-1.893,0L5.573,7.453a1.333,1.333,0,0,0,0,1.893l.547.547a1.333,1.333,0,0,1,.267,1.52h0a1.333,1.333,0,0,1-1.253.893h-.8A1.333,1.333,0,0,0,3,13.64v2.667A1.333,1.333,0,0,0,4.333,17.64H5.12a1.333,1.333,0,0,1,1.253.893h0a1.333,1.333,0,0,1-.267,1.52L5.56,20.6a1.333,1.333,0,0,0,0,1.893l1.88,1.88a1.333,1.333,0,0,0,1.893,0l.547-.547a1.333,1.333,0,0,1,1.52-.267h0a1.333,1.333,0,0,1,.893,1.253v.853A1.333,1.333,0,0,0,13.627,27h2.667a1.333,1.333,0,0,0,1.333-1.333V24.88a1.333,1.333,0,0,1,.893-1.253h0a1.333,1.333,0,0,1,1.52.267l.547.547a1.333,1.333,0,0,0,1.893,0l1.88-1.88a1.333,1.333,0,0,0,0-1.893l-.547-.547a1.333,1.333,0,0,1-.267-1.52h0a1.333,1.333,0,0,1,1.253-.893h.867A1.333,1.333,0,0,0,27,16.373V13.667A1.333,1.333,0,0,0,25.667,12.333Z",
    fill: "none",
    stroke: "#102f74",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearwheel);
export default __webpack_public_path__ + "static/media/gearwheel.cc56ab8f3b343b2f8dd57b11d83b7e75.svg";
export { ForwardRef as ReactComponent };